import {useNavigate} from 'react-router-dom'

import Style from './style'

import MainHeader from 'widget/MainHeader'
import Search from 'widget/Search'
import Pagenation from 'widget/Pagenation'

import useGetAccountList from 'entity/account/useGetAccountList'

import TStyle from 'shared/style/tableStyle'
import timestampCalculator from 'shared/lib/timestampCalculator'
import {convertProGradeAsName} from 'shared/constant/lookup/proGrade'
import SortableHeader from 'shared/ui/SortableHeader'
import TableLoading from 'shared/ui/TableLoading'

const UserList = () => {
	const navigate = useNavigate()

	const [accountList, isLoading] = useGetAccountList()

	const sizeList = [
		'short',
		'expand',
		'medium',
		'short',
		'short',
		'long',
		'long',
		'long',
		'expand',
		'short',
		'long',
	]
	const tableHeadList = [
		{label: 'IDX', sortKey: 'idx'},
		{label: '아이디', sortKey: 'id'},
		{label: '카카오', sortKey: 'is_kakao'},
		{label: '구글', sortKey: 'is_google'},
		{label: '애플', sortKey: 'is_apple'},
		{label: '닉네임', sortKey: 'nickname'},
		{label: '이름', sortKey: 'name'},
		{label: '연락처', sortKey: 'contact'},
		{label: '프로 자격', sortKey: 'pro_grade_flag'},
		{label: '상태', sortKey: 'is_ban'},
		{label: '가입 날짜', sortKey: 'created_at'},
	]

	return (
		<Style.Wrapper>
			<MainHeader>사용자 계정 목록</MainHeader>
			<Search
				placeholder='IDX, 이름, 닉네임, 연락처로 검색'
				qualificationFilter={true}
				statusFilter={true}
				searchGroup='account'
			/>

			<TableLoading isLoading={isLoading}>
				<TStyle.TableDiv>
					<TStyle.TableInner>
						<TStyle.TableRow $title>
							{tableHeadList.map((elem, index) => (
								<TStyle.Data key={index} $title $size={sizeList[index]}>
									<SortableHeader sortKey={elem.sortKey}>
										{elem.label}
									</SortableHeader>
								</TStyle.Data>
							))}
						</TStyle.TableRow>
						{accountList?.data?.account_list?.map((elem, index) => (
							<TStyle.TableRow
								key={index}
								$odd={index % 2 === 1}
								onClick={() => navigate(`/user/${elem?.idx}/detail`)}
							>
								<TStyle.Data $size={sizeList[0]}>{elem?.idx}</TStyle.Data>
								<TStyle.Data $size={sizeList[1]}>{elem?.id || '-'}</TStyle.Data>
								<TStyle.Data $size={sizeList[2]}>
									{elem?.is_kakao && 'Yes'}
								</TStyle.Data>
								<TStyle.Data $size={sizeList[3]}>
									{elem?.is_google && 'Yes'}
								</TStyle.Data>
								<TStyle.Data $size={sizeList[4]}>
									{elem?.is_apple && 'Yes'}
								</TStyle.Data>
								<TStyle.Data $size={sizeList[5]}>{elem?.nickname}</TStyle.Data>
								<TStyle.Data $size={sizeList[6]}>{elem?.name}</TStyle.Data>
								<TStyle.Data $size={sizeList[7]}>
									+{elem?.international_number} {elem?.contact}
								</TStyle.Data>
								<TStyle.Data $size={sizeList[8]}>
									<TStyle.Count>
										{elem?.qualifications?.map((el, ix) => {
											return (
												<p key={ix}>
													{el?.brand_name} - {el?.qualification_name}
												</p>
											)
										})}
									</TStyle.Count>
								</TStyle.Data>
								<TStyle.Data $size={sizeList[9]}>
									{elem?.is_ban ? '정지' : ''}
								</TStyle.Data>
								<TStyle.Data $size={sizeList[10]}>
									{timestampCalculator(elem?.created_at)}
								</TStyle.Data>
							</TStyle.TableRow>
						))}
					</TStyle.TableInner>
				</TStyle.TableDiv>
			</TableLoading>

			<Pagenation maxPage={accountList?.data?.max_page} />
		</Style.Wrapper>
	)
}

export default UserList
